/*
 * Copyright (c) 2021. American Express Company
 */

import { ProgressBarViewModel } from './progress-bar.view.model';

export class ProgressTileViewModel {
    headline: string; // 'You are $progress closer to your savings goals'
    progress?: number;
    progressBar: ProgressBarViewModel;
    width: string; // '100%'|'1000px'

    public static getHeadline(model: ProgressTileViewModel): string {
        return model.headline
            ? model.headline.replace('$progress', `${model.progress || model.progressBar.current}%`)
            : 'headline';
    }
}
